"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(preferenceCookieValue) {
  //! prefCookie means they haven't consented.
  if (!preferenceCookieValue) {
    return -1;
  }
  var value = preferenceCookieValue.replace(':', '');

  // eslint-disable-next-line
  if (isNaN(value)) {
    return 0;
  }
  var parsed = parseInt(value, 10);
  return parsed >= 0 ? parsed : 0;
};